module.exports = __webpack_public_path__ + "img/dot.d4a6a298.svg";